<sm-title-bar
  pageTitle="{{ 'see_profile.title' | translate }}">
</sm-title-bar>
<br />



<div class="help_accd">
  <div class="op_section" style="margin-bottom: 50px;">
    <!-- <div class="page-title-bar mb-4 flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start">
      <div class="title d-flex align-items-center">

        <div>
          <h1>Profile</h1>
        </div>
      </div>
    </div> -->
    <!-- booking cards -->
    <div class="merchant_detail_sec" *ngIf="!loader">
      <div class="mrt_offe">
            <div class="list_user">
                  <mat-card appearance="outlined">
                   <div class="flexbn_sectin">
                    <div class="card_header">
                      <div class="adm_set">
                        <div style="text-align: left;">
                          <div class="card-icon">
                            <img [src]="userDetail.profileThumbImg" alt="" onerror="this.src='../../../../assets/images/user-avatar.svg'">
                          </div>
                        </div>
                      </div>
                      <button
                  mat-icon-button
                  class="share"
                  (click)="editProfile()">
                  <mat-icon class="material-icons-outlined">edit</mat-icon>
                </button>
                    </div>

                 <div class="card_body cbody">
                  
                  <h3 class="name_cont">{{userDetail.name}}</h3>
                  <!-- <div class="entity_detail">
                    {{userDetail.addressInfo.address_line }}
                 </div> -->
                  <div class="hjl_sectin">
                  <!-- <h2 style="font-size: 20px; font-weight: 700;">Basic Info</h2> -->

              </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat"> call </span>
                          </div>

                          <div class="entity_detail make_text_grey">
                            {{ 'see_profile.phone' | translate }}
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 30px;">
                            <!-- {{ _entityDetails[0].ownerPhone }} -->
                            {{userDetail.country_code}} {{userDetail.phone}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat"> mail </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                           Email
                          </div>
                        </div>
                        <div class="sub_one_cont main_text align-items-center">
                          <div class="entity_detail" style="margin-left: 30px;">
                            {{userDetail.email && userDetail.email != 'null' && userDetail.email != '' ? userDetail.email : 'No email added'}}
                          </div>
                          <mat-icon class="material-icons-outlined" style="color: green;margin-left: 5px;" *ngIf="userDetail.email_verification_status == 1 && userDetail.email && userDetail.email != 'null'">check</mat-icon>
                          <mat-icon class="material-icons-outlined" style="color: red;margin-left: 5px;" *ngIf="userDetail.email_verification_status == 0 && userDetail.email && userDetail.email != 'null'">error_outline</mat-icon>
                        </div>
                        <div *ngIf="userDetail.email_verification_status == 0 && userDetail.email && userDetail.email != 'null'">
                               <button class="verify_btn" mat-flat-button color="primary" (click)="sendEmailVerificationLink()"> Verify email</button>
                            </div>
                      </div>
                    </div>
                    <div class="col-md-12" *ngIf="userDetail.addressInfo">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat">
                              location_on
                            </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                            {{ 'see_profile.location' | translate }}
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 30px;">
                            {{userDetail.addressInfo.address_line }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12" *ngIf="userDetail.dateOfBirth && userDetail.dateOfBirth!= 'null'">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat">
                              calendar_month
                            </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                            {{ 'see_profile.dob' | translate }}
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 30px;">
                            {{userDetail.dateOfBirth | date}}
                          </div>
                        </div>
                      </div>
                    </div>
                     <div class="col-md-12" *ngIf="userDetail.gender && userDetail.gender != 'null'">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat">
                              wc
                            </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                            {{ 'see_profile.gender' | translate }}
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 32px;">
                            {{userDetail.gender}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12" >
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat">
                              description
                            </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                            Short bio
                          </div>
                        </div>

                        <div class="sub_one_cont main_text">
                         <div class="entity_detail shortbioz" [class.clamp]="!showFullBio">
                            {{ userDetail.shortBio && userDetail.shortBio !== 'null' ? userDetail.shortBio : 'No bio added' }}
                          </div>
                        </div>
                        <div *ngIf="userDetail.shortBio && userDetail.shortBio !== 'null'" class="toggle-btn" (click)="showFullBio = !showFullBio">
                            {{ showFullBio ? 'Show less' : 'Show more' }}
                          </div>
                      </div>
                    </div>


                    <!--  -->

                    <div class="col-md-12">
                        <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat">
                              person_pin
                            </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                           Active since
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 32px;">
                           {{userDetail.creation_time | date}}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
</mat-card>

      </div>
    </div>
</div>

 


    <!-- loader -->
    <!-- <div *ngIf="loader">
   <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12">
      <ngx-skeleton-loader
      [theme]="{
        width: '100%',
        'border-radius': '10px',
        height: '300px',
        'margin-bottom': '10px',
        'margin-top': '15px',

        float: 'left',
        background: '#d3d3d3'
      }"
    ></ngx-skeleton-loader>
    </div>


   </div>
    </div> -->
  </div>
</div>


